module.exports = __webpack_public_path__ + "img/illustration-2.0896a43b.svg";